import { createHashHistory } from 'history';
import { Container, Row, Col, Button, ButtonGroup, Spinner } from 'reactstrap';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import Icon from '../common/containers/icon';
import Loader from '../common/loader';
import PDF from '../common/pdf/pdf';
const hashHistory = createHashHistory();
const FormDocumentAnnotationEditor = ({
  match: {
    params: {
      formID,
      formDocumentID
    } = {}
  },
  form: {
    active: {
      content
    } = {}
  },
  document: {
    error,
    active,
    downloadPDF
  } = {
    render: {}
  },
  formActions: {
    serverShow
  },
  documentActions: {
    serverRender,
    reset,
    downloadClear,
    serverDownload
  }
}) => {
  var _formDocument$current2;
  if (formID === undefined || formDocumentID === undefined) {
    throw new Error('formDocumentID is required');
  }
  const [maxHeight, setMaxHeight] = useState(1200);
  /**
   * Calculate & Update state of new dimensions
   */
  const updateDimensions = () => {
    // footer is 30 + 20
    // header is 59 + 30
    const verticalMargin = 139;
    if (global.window.innerHeight < 2 * verticalMargin) {
      setMaxHeight(verticalMargin);
    } else {
      setMaxHeight(global.window.innerHeight - verticalMargin);
    }
  };
  useEffect(() => {
    serverShow(formID);
    updateDimensions();
    global.window.addEventListener('resize', updateDimensions);
    //  leave dependencies blank.
    // This assures that we only execute this method once.
  }, [serverShow, formID]);

  // load the form document
  const formDocument = useRef();
  useEffect(() => {
    var _formDocument$current;
    if (content !== undefined && formDocumentID !== undefined && content.associatedDocuments !== undefined && content.associatedDocuments[formDocumentID] !== undefined && ((_formDocument$current = formDocument.current) === null || _formDocument$current === void 0 ? void 0 : _formDocument$current.id) !== formDocumentID) {
      formDocument.current = content.associatedDocuments[formDocumentID];
      formDocument.current.id = formDocumentID;
      serverRender(formDocument.current);
    }
  }, [content, formDocumentID, serverRender]);
  useEffect(() => () => {
    // componentwillunmount in functional component.
    // Anything in here is fired on component unmount.
    reset();
  }, [reset]);
  const handleEditFormClick = () => {
    hashHistory.goBack();
  };
  if (active === null || active === undefined || active.renderedDocument === undefined) {
    return /*#__PURE__*/React.createElement(Spinner, null);
  }
  const {
    renderedDocument
  } = active;
  const {
    pdfPath
  } = renderedDocument;
  const displayName = (_formDocument$current2 = formDocument.current) === null || _formDocument$current2 === void 0 ? void 0 : _formDocument$current2.displayName;
  const buttonGroup = /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 10
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "t-ae-edit-report-btn",
    onClick: handleEditFormClick
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "pencil-alt"
  }), " Edit Form")));
  const handleDownload = () => {
    // need to re-render in the general case where
    // we have added annotations in the editor.  For
    // now, that is not the case, but easier to set
    // it up correctly when we add annotations.
    serverDownload(formDocument.current);
  };
  const handleDownloadClear = () => {
    downloadClear(active);
  };
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    sm: 9
  }, pdfPath ? /*#__PURE__*/React.createElement(PDF, {
    enableEditAnnotations: false,
    src: pdfPath,
    button: buttonGroup,
    title: displayName,
    containerMaxHeight: maxHeight,
    onAnnotationSelect: () => {},
    handleTransition: () => {},
    download: handleDownload,
    downloadPDFPath: downloadPDF,
    downloadClear: handleDownloadClear
  }) : /*#__PURE__*/React.createElement("div", null, error ? `There was an error: ${error}` : /*#__PURE__*/React.createElement(Loader, {
    top: "25%"
  })))));
};
FormDocumentAnnotationEditor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      formDocumentID: PropTypes.string.isRequired
    }).isRequired,
    url: PropTypes.string.isRequired
  }).isRequired,
  form: PropTypes.shape({
    active: PropTypes.shape({
      content: PropTypes.shape({})
    })
  }).isRequired,
  document: PropTypes.shape({
    downloadPDF: PropTypes.string,
    active: PropTypes.shape({
      renderedDocument: PropTypes.shape({
        pdfPath: PropTypes.string
      }),
      formDocument: PropTypes.shape({
        cloudDocumentID: PropTypes.string,
        displayName: PropTypes.string
      })
    }),
    error: PropTypes.string
  }),
  formActions: PropTypes.shape({
    serverShow: PropTypes.func
  }).isRequired,
  documentActions: PropTypes.shape({
    serverRender: PropTypes.func,
    serverDownload: PropTypes.func,
    downloadClear: PropTypes.func,
    reset: PropTypes.func
  }).isRequired
};
export { FormDocumentAnnotationEditor as UnComposedFormDocumentAnnotationEditor };
export default entityComposition(FormDocumentAnnotationEditor, ['form', 'document'], {});